export const BASE_URL=process.env.VUE_APP_BACKEND+"/farmer_groups";